/** Runs tempo + key detection off the main thread so the page stays responsive on long songs. */
import { analyzeSamples } from "./tempoKeyCore";

export function runAnalysis(data, sr) {
  if (typeof Worker === "undefined") return Promise.resolve(analyzeSamples(data, sr));
  return new Promise((resolve, reject) => {
    const w = new Worker(new URL("./tempoKey.worker.js", import.meta.url));
    const done = (fn, v) => { w.terminate(); fn(v); };
    w.onmessage = (e) => (e.data.error ? done(reject, new Error(e.data.error)) : done(resolve, e.data.ok));
    w.onerror = (e) => done(reject, new Error(e.message || "analysis failed"));
    w.postMessage({ data, sr }, [data.buffer]);
  });
}
